import { useIntl } from '@nobia/zeus-components/lib/i18n'
import { useCallback } from 'react'

export const useTranslation = (prefix) => {
  const intl = useIntl()
  const enGbIntl = new Intl.DateTimeFormat('en-GB')

  const t = useCallback(
    (key, variables, skipPrefix) =>
      intl.formatMessage(
        { id: !skipPrefix && prefix ? `${prefix}.${key}` : key },
        variables
      ),
    [intl, prefix]
  )

  return { t, intl, enGbIntl }
}
